import { useContext, useState } from 'react';
import { AppContext } from '../Components/AppProvider';
import { Box, Button, TextField, Typography } from '@mui/material';

const LoginPage = () => {
  const auth = useContext(AppContext);
  const [password, setPassword] = useState('');

  if (!auth) {
    return <p>Error: AppContext not available</p>;
  }

  const handleLogin = () => {
    if (password) {
      auth.login(password);
    } else {
      alert('Please enter a password');
    }
  };

  return (
    <>
      <Box margin={10}>
        <Typography variant="h5" gutterBottom>
          Login
        </Typography>

        <TextField
          label="Enter Password"
          type="password"
          variant="outlined"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <Button variant="contained" color="primary" fullWidth onClick={handleLogin} style={{ marginTop: '1rem' }}>
          Login
        </Button>
      </Box>
    </>
  );
};

export default LoginPage;
